import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { setSelectedNode, setNodeById } from '../../../features/mainSlice';
import { color } from '../../../app/theme';
import Dropdown from '../../shared/Dropdown';
import isSun from '../../../assets/images/svg/ic-sun.svg';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      fontSize: '15px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      marginBottom: 12,
    },
    sun: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$7,
      background: color.$15,
      width: 80,
      borderRadius: '20px',
      justifyContent: 'center',
      padding: '2px 0',
      marginBottom: 6,
    },
    hint: {
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: color.$13,
    },
  },
  {
    name: 'MA',
  },
);

const MA = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedNode, list } = useSelector(state => state.ma);
  const { data } = selectedNode || {};
  const { procedureId } = data || {};
  const menuItems = useMemo(
    () =>
      list.map(l => ({
        text: l?.name,
        value: l?.id,
      })),
    [list],
  );

  const onChange = value => {
    const newNode = {
      ...selectedNode,
      data: { ...selectedNode?.data, procedureId: value },
    };

    dispatch(setSelectedNode(newNode));
    dispatch(setNodeById(newNode));
  };

  return (
    <>
      <div className={classes.root}>
        <div className={classes.title}>{t('ma-setting.name')}</div>
        <Dropdown
          className={classes.dropdown}
          menuItems={menuItems}
          value={procedureId}
          onChange={onChange}
        />
      </div>
      <div className={classes.sun}>
        <img src={isSun} alt="minus" />
        {t('trigger-setting.sun')}
      </div>
      <div className={classes.hint}>{t('ma-setting.hint')}</div>
    </>
  );
};

export default MA;
